// Constraints surfaced to the coach inline on the drop zone.
const MAX_FILE_SIZE_MB = 50;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const MAX_DURATION_LABEL = '3 min';
const FILE_INPUT_ACCEPT = 'video/mp4,video/*';

// How many videos upload at once. A small window keeps the coach's upstream
// pipe saturated without splitting bandwidth across the whole batch; the rest
// of the cards wait in QUEUED and start as slots free up.
const UPLOAD_CONCURRENCY = 3;

// Upload lifecycle for a card's video. Uploads start automatically on drop:
// QUEUED (waiting for a slot) → UPLOADING → UPLOADED, or FAILED at any step.
const UploadStatus = {
  QUEUED: 'queued', // waiting for an upload slot
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded',
  FAILED: 'failed',
  NONE: 'none', // intentionally saving without a video
};

// Which upload step failed — drives what a retry re-runs (a videoId that
// already exists is never discarded, so the byte upload never repeats).
const UploadStep = {
  CREATE: 1, // generateVimeoUpload
  UPLOAD: 2, // byte upload to Vimeo
  MOVE: 3, // moveVimeoVideo (videoId already valid — retry is move-only)
};

// Save lifecycle for a card.
const SaveStatus = {
  IDLE: 'idle',
  SAVING: 'saving',
  SAVED: 'saved',
  SAVE_FAILED: 'savefailed',
};

// Derived, single card status used for the header badge + summary.
const CardStatus = {
  QUEUED: 'queued',
  UPLOADING: 'uploading',
  READY: 'ready',
  NEED: 'need',
  UPLOAD_FAILED: 'failed',
  SAVING: 'saving',
  SAVE_FAILED: 'savefailed',
  SAVED: 'saved',
};

export {
  MAX_FILE_SIZE_MB,
  MAX_FILE_SIZE_BYTES,
  MAX_DURATION_LABEL,
  FILE_INPUT_ACCEPT,
  UPLOAD_CONCURRENCY,
  UploadStatus,
  UploadStep,
  SaveStatus,
  CardStatus,
};
